export default __webpack_public_path__ + "media/images/gift_list/gift-list-intro-image-7fa966ad6283fee4d482ef194a2b28b4.png";